import './App.css';
import RoutesManager from './setup/routes-manager';

function App() {
  return (
    <div className="App">
     <RoutesManager />
    </div>
  );
}

export default App;
